import type { ChildDom } from "vanjs-core";
import type { Device } from "../device/device";
import { t } from "../locale";
import { div, label, option, select } from "./van-tags";

interface Shared {
	device: Device;
	isOwner: boolean;
}

export const deviceOwnerField = (shared: Shared): ChildDom => {
	const onChangeOwner = (e: Event): void => {
		if (!(e.target instanceof HTMLSelectElement)) return;
		shared.device.Metadata.OwnerEmail = e.target.value;
	};

	return div(
		{ class: "field" },
		label({ class: "label" }, () => t.owner),
		div(
			{ class: "control" },
			div({ class: "select" }, () =>
				select(
					{
						disabled: () => !shared.isOwner,
						onchange: onChangeOwner,
						value: () => shared.device.Metadata.OwnerEmail,
					},
					shared.device.Metadata.Access.map((email) =>
						option({
							text: email,
							value: email,
						}),
					),
				),
			),
		),
	);
};
